// extracted by mini-css-extract-plugin
export default {"score":"Score-module__score__ImKp7"};